import api, { adminApiPrefix } from './Api';

const translationAdminApiPrefix = `${adminApiPrefix}/translation`;

export const translateContent = async (
  content: string,
  targetLocale: string,
): Promise<string> => {
  const response = await api.post(translationAdminApiPrefix, {
    content,
    target_locale: targetLocale,
  });

  const result = response.data?.data;
  if (!result) {
    throw new Error(
      'Could not translate content: empty result received from the API',
    );
  }

  return result;
};
